import stylesheet0 from "@oneappexchange/appx-grid";
import stylesheet1 from "@oneappexchange/appx-font-utilities";

function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".link-renderer__paragraph" + shadowSelector + " {margin: var(--wds-link-renderer-margin, 1em 0);}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet0, stylesheet1, stylesheet];